module.exports = __webpack_public_path__ + "static/img/topImg2.5904b19.png";


//////////////////
// WEBPACK FOOTER
// ./static/topImg2.png
// module id = SIIU
// module chunks = 1